export default __webpack_public_path__ + "static/media/qatar.42200bce.png";